import { ITextFieldProps, TextField } from '@fluentui/react';
import React from 'react';
import { ControllerProps, Controller, FieldValues } from 'react-hook-form';

export const ControlledTextField = <T extends FieldValues>(
    props: Omit<ControllerProps<T>, 'render'> & ITextFieldProps,
) => {
    return (
        <Controller
            name={props.name}
            control={props.control}
            rules={props.rules}
            defaultValue={props.defaultValue}
            render={({
                field: { onChange, onBlur, name: fieldName, value },
                fieldState: { error },
            }) => (
                <TextField
                    {...props}
                    onChange={onChange}
                    value={value}
                    onBlur={onBlur}
                    name={fieldName}
                    errorMessage={error && error.message}
                    defaultValue={undefined}
                />
            )}
        />
    );
};
